module.exports = __webpack_public_path__ + "static/media/facebook-f.04b3ee51.svg";